// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"c94aa3c1","50":"e22691a5","104":"5a0a7876","208":"10b70422","279":"6cd42ee2","311":"6f16f502","460":"7aa94359","618":"f8ae8dba","664":"12151986","916":"5f0d5ea0"}[chunkId] + ".chunk.css";
};